import React, { useState } from "react";
import { Form } from "react-bootstrap";

const Dropdown = ({
  label,
  options,
  value,
  onChange,
  optionLabel,
  optionValue,
}) => {
  const [search, setSearch] = useState("");

  const filteredOptions = options.filter((item) =>
    item[optionLabel]
      ?.toLowerCase()
      .includes(search.toLowerCase())
  );

  return (
    <div className="form-group">
      <label>{label}</label>

      {/* 🔍 Search Box */}
      <Form.Control
        type="text"
        placeholder="Search..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="mb-2"
        style={{ minWidth: "200px" }}
      />

      {/* Dropdown */}
      <Form.Select value={value} onChange={onChange} style={{ minWidth: "200px" }}>
        <option value=""  >Select</option>
        {filteredOptions.map((item, index) => (
          <option key={index} value={item[optionValue]}>
            {item[optionLabel]}
          </option>
        ))}
      </Form.Select>
    </div>
  );
};

export default Dropdown;